import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FileService } from 'src/app/services/file/file.service';

@Component({
  selector: 'app-folder-create',
  imports: [CommonModule, FormsModule],
  templateUrl: './folder-create.component.html',
  styleUrls: ['./folder-create.component.css']
})
export class FolderCreateComponent {
  @Input() currentPath: string = '';
  @Output() folderCreated = new EventEmitter<void>();

  folderName: string = '';
  load = false

  constructor(private FileService: FileService){

  }

  createFolder() {
    if (!this.folderName.trim()) return;

    // Example API call (replace with real service call)
    console.log(`Creating folder "${this.folderName}" in path "${this.currentPath}"`);
    const data = {
      'folder_name': this.folderName,
      'patch': this.currentPath
    }
    this.load = true
    this.FileService.createFolder(data).subscribe(
      (res: any) => {
        console.log(res)
        this.load = false
        // On success
        this.folderCreated.emit();
        this.folderName = '';
      },
      (error: any) => {
        this.load = false
        console.log(error)
      }
    )


  }
}
